import { useMutation } from 'react-query';
import { AnchorAPI } from 'client/modules/AnchorAPI';

export function useUpdateUserIntegrationsData() {
  const { mutate, status } = useMutation(
    ({
      userId,
      integrationName,
      userOrigin,
    }: {
      userId: number;
      integrationName: string;
      userOrigin?: string;
    }) => {
      if (!userId) {
        return Promise.reject(
          new Error(
            'userId and integrationName are required parameters to update the user integrations data.'
          )
        );
      }
      return AnchorAPI.updateIntegrationsData({
        userId,
        integrationName,
        ...(userOrigin && { userOrigin }),
      });
    },
    { retry: 2 }
  );

  return { updateIntegrationsData: mutate, status };
}
